/**
 * Tenants that ship a bespoke landing page at `/`.
 *
 * The member SPA resolves `HAS_BESPOKE_LANDING` at BUILD time through the
 * `@app/*` alias (`apps/member/src/tenants/<tenant>/storefront/tenant-landing.tsx`,
 * falling back to a no-op seam). The API has no way to see that, but it has to
 * gate `public_site_info_only`: with the storefront off, a tenant WITHOUT a
 * bespoke landing renders nothing at all at `/`.
 *
 * So this is the one place both sides agree on. Kept deliberately separate from
 * `SiteManifest` — a manifest describes editable CONTENT and only exists for two
 * of these tenants, whereas this answers "does `/` render anything".
 *
 * Guarded by `apps/member/src/tenants/bespoke-landing-registry.test.ts`, which
 * fails if an id here has no `tenant-landing.tsx` on disk.
 */
export const BESPOKE_LANDING_TENANTS = ['upmi', 'agp', 'flx', 'socialpreneur', 'mhyel'] as const;

export type BespokeLandingTenant = (typeof BESPOKE_LANDING_TENANTS)[number];

/** True when `tenant` ships its own landing page at `/`. */
export function hasBespokeLanding(tenant: string | null | undefined): boolean {
  return !!tenant && (BESPOKE_LANDING_TENANTS as readonly string[]).includes(tenant);
}
